<template>
  <div class="comp-wrap_record">
    <el-tooltip effect="dark" content="重新录制" placement="top-start">
      <div class="btn" @click="handleClickRecord">
        <img src="@saas/pages/assets/images/live/recording.png" class="icon" />
        <div class="label">录制中</div>
      </div>
    </el-tooltip>
    <re-record-confirm ref="confirmDialog"></re-record-confirm>
  </div>
</template>

<script>
import ReRecordConfirm from "../dialog/ReRecordConfirm.vue";
export default {
  components: { ReRecordConfirm },

  methods: {
    handleClickRecord() {
      this.$refs.confirmDialog.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-wrap_record {
  -webkit-app-region: none;
  .btn {
    display: flex;
    cursor: pointer;
    .icon {
      width: 18px;
      height: 18px;
    }
    .label {
      margin-left: 3px;
      font-weight: 400;
      font-size: 12px;
      color: #c9cdd4;
    }
  }
}
</style>
